export { default } from "./Menu";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Menu/index.js